import { ITransportAccessibilityRating } from '../../repositories/infrastructure-caching/entities/get_infrastructure/TransportAccessibilityRating';
import { IDistrictTaRating } from '../../types/infrastructure';

/** Переводит рейтинг транспортной доступности от Дептранса в данные панели на карте района. */
export function mapTaRating(rating: ITransportAccessibilityRating | null | undefined): IDistrictTaRating | null {
  if (!rating || (!rating.transport && !rating.infrastructure)) {
    return null;
  }

  return {
    sourceUrl: rating.sourceUrl,
    transport: rating.transport
      ? {
          rate: rating.transport.rate,
          rateDetails: rating.transport.rateDetails.map(({ title, rate }) => ({ title, rate })),
        }
      : undefined,
    infrastructure: rating.infrastructure
      ? {
          rate: rating.infrastructure.rate,
          rateDetails: rating.infrastructure.rateDetails.map(({ title, done }) => ({ title, done })),
        }
      : undefined,
  };
}
